import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rootContainer: {
    display: 'flex',
    minWidth: theme.spacing(83),
    padding: theme.spacing(5),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    borderRadius: theme.spacing(1),
    boxSizing: 'border-box',
    background: '#FFDFC6',
  },
  description: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.tertiary,
    fontFamily: theme.typography.fontFamily,
    marginLeft: theme.spacing(2.5),
  },
  bold: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.labraText.tertiary,
    fontFamily: theme.typography.fontFamily,
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  checkboxContainer: {
    marginBottom: '-8px',
    '& p': {
      paddingTop: theme.spacing(0.25),
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.tertiary,
      fontFamily: theme.typography.fontFamily,
    },
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
}))
